import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {UserSessionRepository} from "../repositories/user-session.repository";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
              private userSessionRepository: UserSessionRepository) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(this.userSessionRepository.isLoggedIn()) {
      if(this.userSessionRepository.isImpersonation()) {
        return true;
      }
      else {
        //terms & Condition code
        if((!this.userSessionRepository.getUserSession()?.agreement)) {
          if (state.url !== '/terms-conditions') {
            this.router.navigate(['/terms-conditions']);
          }
          return true;
        }

        if (!this.userSessionRepository.getUserSession()?.isPasswordPrivate) {
          if (state.url !== '/login/set-new-password') {
            this.router.navigate(['/login/set-new-password']);
            return true;
          }
        }

        return true;
      }
    }

    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});

    return false;
  }
}
